import { Controller } from "@hotwired/stimulus"

// Refresh the server-rendered form through a submitter that skips validation.
export default class extends Controller {
  static targets = ["submitter"]

  refresh(event) {
    const form = event.target.form
    form.elements.namedItem("direction").value = "refresh"
    form.requestSubmit(this.submitterTarget)
  }
}
